import {configureStore} from '@reduxjs/toolkit'
import {setupListeners} from '@reduxjs/toolkit/query'
import {baseApi} from '@/services/api'
import {processingApi} from '@/services/processingApi'

import trackerReducer from '@/features/trackers/trackersSlice'
import deviceReducer from '@/features/devices/devicesSlice'
import filterReducer from '@/features/filters/filtersSlice'
import releaseReducer from '@/features/releases/releasesSlice'
import uiSlice from '@/features/ui/uiSlice'

export const store = configureStore({
  reducer: {
    tracker: trackerReducer,
    device: deviceReducer,
    filters: filterReducer,
    release: releaseReducer,
    ui: uiSlice,
    [baseApi.reducerPath]: baseApi.reducer,
    [processingApi.reducerPath]: processingApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware, processingApi.middleware),
  // devTools: true
})

// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch)

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
